export default () => ({
    expanded: false,

    state: {
        [':class']: 'expanded ? "--is-open" : ""',
    },

    trigger: {
        [':aria-expanded']: 'expanded',
        [':aria-label']: '"toggle element"'
    },

    toggle() {
        this.expanded = ! this.expanded
    },
})
